import React from 'react'
import nodata from '../../assets/images/no-data.png';
const NoData = ({text}) => {
  return (
    <div className='nodata-content'>
          <div className='text-center'>
            <img src={nodata} width={100} className='mx-auto' alt="No Data"></img>
            <p className='mb-0 font-medium text-dark-addonColor mt-2'>{text || "No Data Available"}</p>
          </div>
        </div>
  )
}

export default NoData